import {
  PriceList,
  PriceListEditFormValues,
  PriceListRow,
  PriceTable,
} from "./types";

/*---------------------------------------------------------------------------------------
    PRICE LIST  VALUE 
-----------------------------------------------------------------------------------------*/
export const transformPriceList = (res: any): PriceList => {
  return {
    id: res.id,
    name: res.name,
    vehicleGroupId: res.vehicleGroupId,
  };
};

/*---------------------------------------------------------------------------------------
    PRICE LIST  VALUE SEARCH
-----------------------------------------------------------------------------------------*/

export const transformPriceListRow = (res: any): PriceListRow => {
  return {
    id: res.id,
    name: res.name,
  };
};

/*---------------------------------------------------------------------------------------
      PRICE LIST  VALUE CREATE
  -----------------------------------------------------------------------------------------*/

export const transformPriceListOnCreate = (
  formValues: PriceListEditFormValues
): any => ({
  name: formValues.name,
});

/*---------------------------------------------------------------------------------------
  PRICE LIST VALUE EDIT
-----------------------------------------------------------------------------------------*/

export const transformPriceListOnUpdate = (
  formValues: PriceListEditFormValues
): any => ({
  id: formValues.id,
  name: formValues.name,
});

/*---------------------------------------------------------------------------------------
  PRICE LIST TABLE
-----------------------------------------------------------------------------------------*/
export const transformPriceTable = (res: any): PriceTable => {
  return {
    id: res.id,
    name: res.name,
    rentDurations: res.rentDurations,
    rentVehicleModels: res.rentVehicleModels,
    values: res.values,
  };
};
